import { UserHtml } from "client/Features/UserHtml/UserHtml";
import { ReactElement } from "react";
import styles from "./Embed.module.less";

export type EmbedProps = {
	code: string;
};

export const Embed = (props: EmbedProps): ReactElement => {
	const { code } = props;

	return (

		<div className={styles.embed}>
			<UserHtml
				html={code}
				trackingId="embed-element-iframe"
			/>
		</div>
	);
};
Embed.displayName = "ContentLayout.Embed";
